exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-body.overflow-auto[data-v-bb7d7518]{overflow:auto}.pagination[data-v-bb7d7518]{display:inline-block!important}", ""]);

// exports
